<top-bar-progress-bar />
<sidenav />
<sign-up-header *ngIf="isSignUpHeader" />
<div class="header-base-panel-wrapper">
  <intilio-header *ngIf="!hideHeader && !isSignUpHeader" />
  <div
    class="base-panel w-100"
    (scroll)="onScroll()"
    [ngClass]="{
      'base-panel--hidden-header': hideHeader,
      'base-panel--mobile': DeviceHelper.isMobileDevice,
      'base-panel--sticky-footer': isFooterSticky,
      'base-panel--ipad': DeviceHelper.isIPad
    }"
    #basePanel
  >
    <router-outlet />
    <intilio-footer *ngIf="!hideFooter" />
  </div>
</div>
